// context/RoomSettingsContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const RoomSettingsContext = createContext();

export const RoomSettingsProvider = ({ children }) => {
    const [roomSettings, setRoomSettings] = useState(() => {
        try {
            const stored = localStorage.getItem("roomSettings");
            return stored ? JSON.parse(stored) : null;
        } catch (error) {
            console.error("Failed to parse room settings:", error);
            return null;
        }
    });

    useEffect(() => {
        if (roomSettings) {
            localStorage.setItem("roomSettings", JSON.stringify(roomSettings));
        } else {
            localStorage.removeItem("roomSettings");
        }
    }, [roomSettings]);

    return (
        <RoomSettingsContext.Provider value={{ roomSettings, setRoomSettings }}>
            {children}
        </RoomSettingsContext.Provider>
    );
};

export const useRoomSettings = () => useContext(RoomSettingsContext);
